import axios from 'axios';
import { BASE_URI_DEVELOPMENT_CENTER } from '@/api/CONST.js';

/**
 * get homework
 * @param {number|string} activityId activity id
 * @returns Promise
 */
export const getHomeworkBlock = activityId => axios.get(`${BASE_URI_DEVELOPMENT_CENTER}/homework-activities/${activityId}`);

export const getHomeworkBlockList = (activityId, page) => axios.get(`${BASE_URI_DEVELOPMENT_CENTER}/homework-activities/${activityId}/homework`, { params: { page } });

/**
 * @param {number|string} versionId
 * @param {number|string} page
 * @param {'HomeworkFiles' | 'EssayHomework'} type
 * @param {boolean} typeAcceptance
 * @param {'newest' | 'oldest'} sort
 * @returns {Promise<AxiosResponse>} Promise
 */
export const getVersionHomeworkActivities = ({ versionId, page, type, typeAcceptance, sort }) => axios.get(`${BASE_URI_DEVELOPMENT_CENTER}/versions/${versionId}/homework-activities`, {
    params: {
        page,
        type,
        type_acceptance: typeAcceptance,
        sort,
    },
});

/**
 * Получить домашнее задание
 * @param id
 * @returns {Promise<AxiosResponse<any>>}
 */
export const fetchHomework = id => axios.get(`${BASE_URI_DEVELOPMENT_CENTER}/homework/${id}`);

/**
 * Получить историю домашнего задания
 * @param id
 * @param cursor Хэш курсорной пагинации
 * @returns {Promise<AxiosResponse<any>>}
 */
export const fetchHomeworkHistory = (id, cursor) => axios.get(`${BASE_URI_DEVELOPMENT_CENTER}/homework/${id}/history`, { params: { cursor } });

/**
 * Получить элемент истории домашнего задания
 * @param id
 * @returns {Promise<AxiosResponse<any>>}
 */
export const fetchHomeworkHistoryItem = ({ homeworkId, historyId }) => axios.get(`${BASE_URI_DEVELOPMENT_CENTER}/homework/${homeworkId}/history/${historyId}`);

/**
 * Создать ответ для домашнего задания
 * @param homeworkId
 * @param versionId
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 */
export const createHomeworkResponse = ({ homeworkId, versionId, data }) => axios.post(`${BASE_URI_DEVELOPMENT_CENTER}/homework/${homeworkId}/versions/${versionId}/responses`, data);

/**
 * Обновить ответ домашнего задания
 * @param homeworkId
 * @param versionId
 * @param responseId
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 */
export const updateHomeworkResponse = ({ homeworkId, versionId, responseId, data }) => axios.put(`${BASE_URI_DEVELOPMENT_CENTER}/homework/${homeworkId}/versions/${versionId}/responses/${responseId}`, data);

/**
 * Отменить ответ домашнего задания и создать новый
 * @param homeworkId
 * @param versionId
 * @param responseId
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 */
export const cancelAndCreatHomeworkResponse = ({ homeworkId, versionId, responseId, data }) => axios.post(`${BASE_URI_DEVELOPMENT_CENTER}/homework/${homeworkId}/versions/${versionId}/responses/${responseId}/cancel`, data);
